import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type BackButtonClickedProps = EventProps

/**
 * @event back_button_clicked
 * @description Emitted when the header back button is pressed.
 */
export const BackButtonClickedAnalytics = createAnalyticsStatic<BackButtonClickedProps>(
    ANALYTICS_EVENTS.BACK_BUTTON_CLICKED,
)

export default BackButtonClickedAnalytics
